<template>
    <nav v-if="isAuthenticated && venueChosen && !isInventoryOnly" 
         class="navigationBar" 
         :class="{ 'navigation-expanded': navigationExpanded }"
         @mouseenter="!isTouchDevice ? openNavigation() : null"
         @mouseleave="!isTouchDevice ? closeNavigation() : null"
         @click="isTouchDevice ? toggleNavigation() : null">
        <a class="navigationBar-brand">
            <svg class="brand-small" width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9642 11.9414H14.4612C15.2825 10.8181 15.7619 9.46759 15.7619 8.01293C15.7619 5.83324 17.6525 4.06009 19.9642 4.06009C22.3013 4.06009 24.1654 5.83324 24.1654 8.01293C24.1654 10.167 22.3013 11.9414 19.9642 11.9414ZM7.96233 11.9414C5.65174 11.9414 3.76135 10.167 3.76135 8.01293C3.76135 5.83324 5.65174 4.06009 7.96233 4.06009H13.469C12.6453 5.18962 12.1644 6.54777 12.1644 8.01293C12.1644 10.167 10.2994 11.9414 7.96233 11.9414ZM19.9642 0.891113C17.5512 0.891113 15.3937 1.88521 13.9627 3.45559C12.5329 1.88521 10.3753 0.891113 7.96236 0.891113C5.25306 0.891113 2.86554 2.14532 1.46724 4.06004C0.64355 5.18957 0.162598 6.54772 0.162598 8.01288C0.162598 11.9414 3.65634 15.1093 7.96236 15.1093C10.3753 15.1093 12.5329 14.1152 13.9627 12.5497C15.3937 14.1152 17.5512 15.1093 19.9642 15.1093C22.6759 15.1093 25.065 13.8538 26.4619 11.9414C27.2832 10.818 27.7626 9.46754 27.7626 8.01288C27.7626 4.06004 24.2702 0.891113 19.9642 0.891113Z" fill="#00C164"/>
            </svg>
            <svg class="brand-big" width="92" height="25" viewBox="0 0 92 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_39980_31853)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.15905 16.539C5.76403 16.539 4.52748 16.0895 3.65889 15.3232V9.56343C4.55274 8.79685 5.79062 8.32201 7.15905 8.32201C9.60663 8.32201 11.4491 10.0919 11.4491 12.4432C11.4491 14.874 9.60663 16.539 7.15905 16.539ZM7.81707 5.01807C6.31677 5.01807 4.84333 5.44086 3.65888 6.12844V5.28285H0V24.2544H3.65888V18.7581C4.84333 19.4457 6.29019 19.8418 7.81707 19.8418C11.7915 19.8418 15.0545 16.8561 15.0545 12.4431C15.0545 7.95147 11.7915 5.01807 7.81707 5.01807V5.01807Z" fill="#00C164"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M47.6729 19.2364H51.0183V0H47.6729V19.2364Z" fill="#00C164"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M54.3638 19.2362H57.7092V5.01807H54.3638V19.2362Z" fill="#00C164"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M68.4198 5.01807C66.9941 5.01807 65.6971 5.42946 64.6597 6.15043V5.27571H61.0547V19.2362H64.6597V9.33793C65.4632 8.64423 66.5003 8.23284 67.7714 8.23284C69.7682 8.23284 70.8312 9.28599 70.8312 11.4463V19.2362H74.4365V11.4463C74.4365 6.92101 72.5435 5.01807 68.4198 5.01807" fill="#00C164"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M88.3413 15.3232C87.4458 16.0895 86.2095 16.539 84.8144 16.539C82.3668 16.539 80.5509 14.874 80.5509 12.4432C80.5509 10.0919 82.3668 8.32201 84.8144 8.32201C86.2095 8.32201 87.4208 8.79685 88.3413 9.56343V15.3232ZM88.3412 5.28285V6.12844C87.1567 5.44086 85.6567 5.01807 84.1561 5.01807C80.1818 5.01807 76.9453 7.95147 76.9453 12.4431C76.9453 16.8561 80.1818 19.8418 84.1561 19.8418C85.7098 19.8418 87.1301 19.4457 88.3412 18.7581V24.2544H91.9999V5.28285H88.3412V5.28285Z" fill="#00C164"/>
                </g>
                <defs>
                <clipPath id="clip0_39980_31853">
                <rect width="92" height="24.2545" fill="white"/>
                </clipPath>
                </defs>
            </svg>
        </a>
        <ul class="mainNavigation">
            <li>
                <router-link to="/" @click.native.stop="onRouterLinkClick">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_39971_1067" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" rx="1" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_39971_1067)">
                        <path d="M14 9C13.4477 9 13 8.55228 13 8V4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 20.5523 9 20 9H14ZM4 13C3.44772 13 3 12.5523 3 12V4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V12C11 12.5523 10.5523 13 10 13H4ZM14 21C13.4477 21 13 20.5523 13 20V12C13 11.4477 13.4477 11 14 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H14ZM4 21C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15H10C10.5523 15 11 15.4477 11 16V20C11 20.5523 10.5523 21 10 21H4Z" fill="#0CBA4A"/>
                        </g>
                    </svg>
                    <span>{{ $t('navigation.dashboard') }}</span>
                </router-link>
            </li>
            <!-- <li><router-link to="/register" v-if="!isAuthenticated">SIGN UP</router-link></li> -->
            <!-- <li><router-link to="/login" v-if="!isAuthenticated">LOGIN</router-link></li> -->
            <li>
                <router-link to="/wines" v-if="isAuthenticated" @click.native.stop="onRouterLinkClick">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_39971_1070" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" rx="1" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_39971_1070)">
                        <path d="M18.5474 21H14.4565" stroke="#0CBA4A" stroke-width="2" stroke-linecap="round"/>
                        <path d="M16.5015 16.2275V21.0003" stroke="#0CBA4A" stroke-width="2" stroke-linecap="round"/>
                        <path d="M18.8472 7L19.6597 10.918C19.8139 11.6622 19.7546 12.4354 19.4888 13.1475L19.4604 13.2217C19.0848 14.2276 18.3154 15.0373 17.3296 15.4629C16.8012 15.6909 16.2017 15.691 15.6733 15.4629C14.6875 15.0373 13.9181 14.2276 13.5425 13.2217L13.5142 13.1475C13.2483 12.4353 13.1899 11.6623 13.3442 10.918L14.1567 7H18.8472Z" stroke="#0CBA4A" stroke-width="2"/>
                        <path d="M19.0697 11.5001C16.5696 11.0001 16.0697 13.0001 14.0697 12.0001C13.9867 12.6928 14.3787 14.8243 16.5696 14.9905C18.7606 15.1568 19.1527 12.5392 19.0697 11.5001Z" fill="#0CBA4A"/>
                        <path d="M5.25732 3C5.25732 2.44771 5.70504 2 6.25732 2H6.88232C7.43461 2 7.88232 2.44772 7.88232 3V8.53417C7.88232 8.61394 7.93159 8.68544 8.00615 8.71384L8.12298 8.75834C9.29518 9.2049 10.0698 10.329 10.0698 11.5833V21C10.0698 21.5523 9.62211 22 9.06982 22H4.06982C3.51754 22 3.06982 21.5523 3.06982 21V11.5833C3.06982 10.329 3.84447 9.2049 5.01667 8.75834L5.1335 8.71384C5.20806 8.68544 5.25732 8.61394 5.25732 8.53417V3Z" fill="#0CBA4A"/>
                        </g>
                    </svg>
                    <span>{{ $t('navigation.winelist') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/insights" v-if="isAuthenticated" @click.native.stop="onRouterLinkClick">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_39971_1080" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_39971_1080)">
                        <path d="M3.1875 20.75C2.92917 20.75 2.70833 20.6583 2.525 20.475C2.34167 20.2917 2.25 20.0708 2.25 19.8125V9.1875C2.25 8.92917 2.34167 8.70833 2.525 8.525C2.70833 8.34167 2.92917 8.25 3.1875 8.25H6.5C6.75833 8.25 6.97917 8.34167 7.1625 8.525C7.34583 8.70833 7.4375 8.92917 7.4375 9.1875V19.8125C7.4375 20.0708 7.34583 20.2917 7.1625 20.475C6.97917 20.6583 6.75833 20.75 6.5 20.75H3.1875ZM10.3375 20.75C10.0792 20.75 9.85833 20.6583 9.675 20.475C9.49167 20.2917 9.4 20.0708 9.4 19.8125V4.1875C9.4 3.92917 9.49167 3.70833 9.675 3.525C9.85833 3.34167 10.0792 3.25 10.3375 3.25H13.6625C13.9208 3.25 14.1417 3.34167 14.325 3.525C14.5083 3.70833 14.6 3.92917 14.6 4.1875V19.8125C14.6 20.0708 14.5083 20.2917 14.325 20.475C14.1417 20.6583 13.9208 20.75 13.6625 20.75H10.3375ZM17.5 20.75C17.2417 20.75 17.0208 20.6583 16.8375 20.475C16.6542 20.2917 16.5625 20.0708 16.5625 19.8125V13.1875C16.5625 12.9292 16.6542 12.7083 16.8375 12.525C17.0208 12.3417 17.2417 12.25 17.5 12.25H20.8125C21.0708 12.25 21.2917 12.3417 21.475 12.525C21.6583 12.7083 21.75 12.9292 21.75 13.1875V19.8125C21.75 20.0708 21.6583 20.2917 21.475 20.475C21.2917 20.6583 21.0708 20.75 20.8125 20.75H17.5Z" fill="#0CBA4A"/>
                        </g>
                    </svg>
                    <span>{{ $t('navigation.insights') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/reports" v-if="isAuthenticated" @click.native.stop="onRouterLinkClick">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_35171_28569)">
                        <mask id="mask0_35171_28569" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_35171_28569)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9492 20.4713C18.582 20.8238 18.1406 21 17.625 21H6.375C5.85938 21 5.41797 20.8238 5.05078 20.4713C4.68359 20.1188 4.5 19.695 4.5 19.2V4.8C4.5 4.305 4.68359 3.88125 5.05078 3.52875C5.41797 3.17625 5.85938 3 6.375 3H13.1016C13.3516 3 13.5898 3.045 13.8164 3.135C14.043 3.225 14.2422 3.3525 14.4141 3.5175L18.9609 7.8825C19.1328 8.0475 19.2656 8.23875 19.3594 8.45625C19.4531 8.67375 19.5 8.9025 19.5 9.1425V19.2C19.5 19.695 19.3164 20.1188 18.9492 20.4713ZM8.45876 17.1822C8.59793 17.3274 8.76556 17.4 8.96167 17.4H10.5482C10.7443 17.4 10.9119 17.3274 11.0511 17.1822C11.1903 17.037 11.2599 16.8621 11.2599 16.6575V9.1425C11.2599 8.9379 11.1903 8.763 11.0511 8.6178C10.9119 8.4726 10.7443 8.4 10.5482 8.4H8.96167C8.76556 8.4 8.59793 8.4726 8.45876 8.6178C8.31959 8.763 8.25 8.9379 8.25 9.1425V16.6575C8.25 16.8621 8.31959 17.037 8.45876 17.1822ZM12.9584 17.1822C13.0975 17.3274 13.2652 17.4 13.4613 17.4H15.0383C15.2344 17.4 15.4021 17.3274 15.5412 17.1822C15.6804 17.037 15.75 16.8621 15.75 16.6575V12.3105C15.75 12.1059 15.6804 11.931 15.5412 11.7858C15.4021 11.6406 15.2344 11.568 15.0383 11.568H13.4613C13.2652 11.568 13.0975 11.6406 12.9584 11.7858C12.8192 11.931 12.7496 12.1059 12.7496 12.3105V16.6575C12.7496 16.8621 12.8192 17.037 12.9584 17.1822Z" fill="#0CBA4A"/>
                        </g>
                        </g>
                        <defs>
                        <clipPath id="clip0_35171_28569">
                        <rect width="24" height="24" fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>
                    <span>{{ $t('navigation.reports') }}</span>
                </router-link>
            </li>
            <!--
            <li>
                <router-link to="/winecard" v-if="isAuthenticated">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fill-rule="evenodd">
                            <path d="M0 0h24v24H0z"/>
                            <path d="M21 5h2v14h-2V5zm-4 0h2v14h-2V5zm-3 0H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H3V7h10v10z" fill="#0CBA4A" fill-rule="nonzero"/>
                            <path d="m9.505 10.616-.349-.128a.4.4 0 0 1-.247-.38V8.4c0-.22-.164-.4-.364-.4h-1.09c-.2 0-.364.18-.364.4v1.712a.4.4 0 0 1-.247.38l-.35.128c-.294.112-.494.416-.494.76v3.82c0 .44.327.8.727.8h2.546c.4 0 .727-.36.727-.8v-3.824c0-.344-.2-.648-.495-.76zM9 15H7v-3h2v3z" fill="#0CBA4A" fill-rule="nonzero"/>
                        </g>
                    </svg>
                    <span>{{ $t('navigation.winecard') }}</span>
                </router-link>
            </li>
            -->
            <li>
                <router-link to="/inventories" v-if="isAuthenticated" @click.native.stop="onRouterLinkClick">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_39971_1092" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_39971_1092)">
                        <path d="M11.0385 22V12.7143L3 7.98701V16.1948C3 16.5498 3.08333 16.8745 3.25 17.1688C3.41667 17.4632 3.65385 17.697 3.96154 17.8701L11.0385 22ZM12.9615 22L20.0385 17.8831C20.3462 17.71 20.5833 17.474 20.75 17.1753C20.9167 16.8766 21 16.5498 21 16.1948V8.01299L12.9615 12.7013V22ZM16.9487 8.14286L20.0256 6.35065L12.9615 2.25974C12.6538 2.08658 12.3333 2 12 2C11.6667 2 11.3462 2.08658 11.0385 2.25974L8.97436 3.45455L16.9487 8.14286ZM12 11.039L15.0256 9.27273L7.0641 4.57143L4.01282 6.35065L12 11.039Z" fill="#0CBA4A"/>
                        </g>
                    </svg>
                    <span>{{ $t('navigation.inventory') }}</span>
                </router-link>
            </li>
            <!-- <li><router-link to="" v-if="isAuthenticated">User: {{ getUser.username }}</router-link></li> -->
            <!-- <li><router-link to="" v-if="isAuthenticated && venueChosen">Venue: {{ getVenue.attributes.title }}</router-link></li> --> 
        </ul>
        <div class="listContainer">
            <span class="listLabel">Listen</span>
            <ul class="playListsContainer">
                <li v-if="hasPlaylist">
                    <Container @mouseenter.native="setChoosenPlaylist(-2)" group-name="playlistDrop" behaviour="drop-zone" class="dropzone deleteFromList" @drop="onDrop($event, null)">
                        <span>{{ $t('navigation.deleteWineFromList') }}</span>
                    </Container>
                </li>
            </ul>    
            <ul v-if="hasSmartList" class="smartListsContainer">
                <li :class="isFavorites(smartList.attributes.type) + ' ' + isActiveSmartList(smartList.id)" v-for="smartList in getVenue.attributes.smartLists.data" :key="smartList.id" @click="showSmartList(smartList)">
                    <span v-if="smartList.attributes.type === 'favorite'">{{ $t('navigation.smartListFavorites') }}</span>
                    <span v-else>{{smartList.attributes.title}}</span>
                </li>
            </ul>
            <ul class="playListsContainer">
                <li>
                    <Container @mouseenter.native="setChoosenPlaylist(element.id)" v-for="(element, key) in getVenue.attributes.playlists.data" group-name="playlistDrop" :class="'dropzone ' + isActiveList(element.id)" @drop="onDrop($event, element.id)" :key="key">
                        <span @click="showPlaylist(element.id)" >{{element.attributes.title}}</span>
                    </Container>
                </li>
            </ul>
            <!--
            <Container group-name="playlistDrop" class="dropzone" @drop="onDrop($event, 'playlist2')">
                <span @mouseenter="setChoosenPlaylist('playlist2')">Playlist 2</span>
            </Container>
            -->
        </div>  
        <div class="addPlaylistContainer">
            <b-button class="addPlaylist" @click="addPlaylist()">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z"/>
                        <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#0CBA4A" fill-rule="nonzero"/>
                    </g>
                </svg>
                <span>{{ $t('navigation.createNewList') }}</span>
            </b-button>
        </div>
    </nav>
</template>
<script>
    //import DataService from '@/services/StrapiService'
    import { mapGetters } from 'vuex'
    import { Container } from "vue-dndrop"
    import DataService from '@/services/StrapiService'

    export default {
        name: 'Nav',
        components: {
            Container
         },
        data() {
            return {
                choosenPlaylist: "",
                navigationExpanded: false,
                isTouchDevice: false
            }
        },
        computed: {
            path: function () {
                return this.$router.currentRoute.path
            },
            loggedIn: function () {
                return this.getUser.username != null
            },
            hasPlaylist: function () {
                return this.getFilter.playlist != null
            },
            hasSmartList: function() {
                return !this.isInventoryOnly && this.getVenue.attributes != null 
                && this.getVenue.attributes.smartLists.data != null 
                && this.getVenue.attributes.smartLists.data.length > 0
            },
            ...mapGetters(['isAuthenticated', 'venueChosen', 'getUser', 'getVenue', 'getFilter', 'getReloadVenue','isInventoryOnly']),
        },
        created () {
            // Detect if this is a touch device
            this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        },
        mounted() {
            // Add click outside listener for touch devices
            if (this.isTouchDevice) {
                document.addEventListener('touchstart', this.handleClickOutside);
                document.addEventListener('click', this.handleClickOutside);
            }
        },
        beforeDestroy() {
            if (this.isTouchDevice) {
                document.removeEventListener('touchstart', this.handleClickOutside);
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        methods: {
            onDrop(dropResult, playlistId) {
                if (this.choosenPlaylist === -2) {
                  this.choosenPlaylist = -1 // reset to not fire more delete events
                    DataService.deleteVenueWineFromPlaylist(dropResult.element.id, this.getFilter.playlist).then(() => {
                        var alertobject = {
                            text: this.$t('navigation.wineDeletedFromList'),
                            variant: 'danger'
                        }
                        this.$store.commit('setAlertText', alertobject)
                        this.$store.commit('reloadWines')
                    }).catch((err) => {
                        console.log(err)
                    })
                } else if ( this.choosenPlaylist === playlistId ) {
                    DataService.getPlaylist(playlistId).then((response) => {
                        var playlist = response['data'].data
                        var found = false
                        playlist.attributes.venueWines.data.forEach(wine => {
                          if (wine.attributes.wine.data.id == dropResult.element.id) {
                            found = true
                          }
                        });
                        if (found) {
                          var alertobject = {
                              text: this.$t('navigation.wineAlreadyInList'),
                              variant: 'danger'
                          }
                          this.$store.commit('setAlertText', alertobject)
                        } else {
                            playlist.attributes.venueWines.data.push(dropResult.element.id)

                            DataService.updatePlaylist(playlistId, playlist).then(() => {
                                this.$store.commit('reloadVenue')
                                var alertobject = {
                                    text: this.$t('navigation.wineAddedToList'),
                                    variant: 'info'
                                }
                                this.$store.commit('setAlertText', alertobject)
                          }).catch((err) => {
                              console.log(err)
                          })
                        }
                       
                    }).catch((err) => {
                        console.log(err)
                    })
                } 
            },
            onDropDelete(dropResult) {
                DataService.deleteVenueWineFromPlaylist(dropResult.element.id, this.getFilter.playlist).then(() => {
                        var alertobject = {
                            text: this.$t('navigation.wineDeletedFromList'),
                            variant: 'danger'
                        }
                        this.$store.commit('setAlertText', alertobject)
                        this.$store.commit('reloadWines')
                    }).catch((err) => {
                        console.log(err)
                    })
            },
            setChoosenPlaylist(playlist) {
                this.choosenPlaylist = playlist
            },
            resetChosenVenue() {
                this.$store.commit('updateVenue', {})
                this.$router.push('/venues')
                // this.$router.push('/')
            },
            addPlaylist () {
                this.$emit('messageFromNav', 'addPlaylist')
            },
            showPlaylist (id) {
                var filter = { playlist : id}
                this.$store.commit('updateFilter', filter)
                this.$router.push({ name: 'Wines', query: { playlistId: id.toString() } })
            },
            showSmartList (smartList) {
                var filter = { smartList : smartList.id }
                this.$store.commit('updateFilter', filter)
                this.$router.push({ name: 'Wines', query: { smartListId: smartList.id.toString() } })
            },
            isFavorites (smartListType) {
                // Hier muss noch Lokalisierung eingebaut werden! Evtl. Mechanik überdenken.
                if( smartListType === "favorite" ) {
                    return "favorits"
                }
            },
            isActiveList (listId) {
                var playlistId = this.$route.query.playlistId
                if( playlistId == listId ) {
                    return "active"
                }
            },
            isActiveSmartList (listId) {   
                var smartListId = this.$route.query.smartListId
                if( smartListId == listId ) {
                    return "active"
                }
            },
            toggleNavigation() {
                if (this.isTouchDevice) {
                    // On touch devices, always open navigation on first click
                    if (!this.navigationExpanded) {
                        this.openNavigation();
                    }
                    // Don't toggle closed - only links should close it
                }
            },
            openNavigation() {
                this.navigationExpanded = true;
            },
            closeNavigation() {
                this.navigationExpanded = false;
            },
            onRouterLinkClick(event) {
                console.log("Router link clicked");
                console.log("isTouchDevice: " + this.isTouchDevice);
                console.log("navigationExpanded: " + this.navigationExpanded);
                // On touch devices, prevent navigation if bar is not expanded
                if (this.isTouchDevice && !this.navigationExpanded) {
                    console.log("Touch device - open navigation");
                    event.preventDefault();
                    event.stopPropagation();
                    this.openNavigation();
                    return;
                }
                
                // If bar is expanded, allow navigation and close after delay (only on touch devices)
                if (this.isTouchDevice && this.navigationExpanded) {
                    this.closeNavigation();
                }
                
                // Stop event propagation to prevent toggleNavigation from being called
                if (event) {
                    event.stopPropagation();
                }
            },
            handleClickOutside(event) {
                // Check if click is outside navigation
                const nav = this.$el;
                if (nav && !nav.contains(event.target) && this.navigationExpanded) {
                    this.closeNavigation();
                }
            },
        },
        watch:{
            '$route' (to){
                if (to.name !== 'Wines') {
                    var filter = { }
                    this.$store.commit('updateFilter', filter)
                }
            },
            getReloadVenue() {
                DataService.getVenueDetail().then((response) => {
                    this.$store.commit('updateVenue', response['data'].data)
                }).catch((err) => {
                    console.log(err)
                })
            },
        },
    }
</script>
<style scoped>
</style>
            